import axios from 'axios'
import { createStore } from 'vuex'
import { APIS_INVENTORY } from '@/constants/apis'
import { TIMEOUTTIME } from '@/constants/apis'
import { LABELS, TOKEN } from '@/constants/labels'
import { getAllUsersData } from '@/services/RAOS/Admin'

export default createStore({
  state: {
    showInfoMap: 'hideALL',
    showLineMap: true,
    centerMap: [],
    zoomMap: 0,
    sesion: {
      user: '',
      status: '',
      rol: '',
      mina: '',
    },
    snackbar: {
      type: '',
      msg: '',
      valor: false
    },
    valueKPI: '',//
    arrayListItems: [],//
    arrayUserInfo: [],//

    //Variable de tipo TOPO_GENERAL
    arrayItemsByStatus: [],

    arrayTotalKPI: [],//
    overlayLoading: false,//
    snackbarAdd: false,//
    snackbarEdit: false,//
    snackbarDelete: false,//
    snackbarError: false,//
    snackbarmsg: '',//
    drawer: true,//
    showVirMac: true,//
    ieoDistri: '',//
    ieoAcceso: '',//
    ieoClient: '',//
    appBarPage: 'styles__demo',//
    projectName: `${process.env.VUE_APP_NAME_PROJECT}`,
    projectLAT: parseFloat(process.env.VUE_APP_MAP_LAT_CANANEA ?? ''),
    projectLNG: parseFloat(process.env.VUE_APP_MAP_LNG_CANANEA ?? ''),
    projectZOOM: parseFloat(process.env.VUE_APP_MAP_ZOOM_CANANEA ?? ''),
  },
  mutations: {
    // desde login, AppBar
    setInfoMapCheckBoxes(state, showinfo) {
      state.showInfoMap = showinfo
    },
    setLineMapCheckBoxes(state, showLine) {
      state.showLineMap = showLine
    },
    setAppBarPage(state, page) {
      state.appBarPage = page
    },
    setProjectName(state, project) {
      state.projectName = project
    },
    setProjectLAT(state, latitud) {
      state.projectLAT = latitud
    },
    setProjectLNG(state, longitud) {
      state.projectLNG = longitud
    },
    setProjectZOOM(state, zoom) {
      state.projectZOOM = parseInt(zoom)
    },
    // Desde GaugeComponent
    setIEODistri(state, IEOdistri) {
      state.ieoDistri = IEOdistri
    },
    // Desde GaugeComponent
    setIEOAcceso(state, IEOAcceso) {
      state.ieoAcceso = IEOAcceso
    },
    // Desde GaugeComponent
    setIEOClient(state, IEOCliente) {
      state.ieoClient = IEOCliente
    },
    // desde login, APPBar
    setUserSesion(state, value) {
      state.sesion = value
    },
    // desde login
    setUserRol(state, value) {
      state.sesion.rol = value
    },
    // Desde KPI-component
    setTotalKPI(state, value) {
      state.arrayTotalKPI = value
    },
    // desde Drawer Bar
    postKPIValue(state, value) {
      state.valueKPI = value
    },
    // Desde la Accion
    addListItems(state, value) {
      state.arrayListItems = value
    },

    allUserInfo(state, value) {
      state.arrayUserInfo = value
    },

    /**
     * Recibe el array de objetos con valores: 
     * name, tipo, subtipo, ip, marca, status
     * lo almacena en la STORE para usarse en otro momento
     * @param state 
     * @param value 
     */
    addAllItemsByStatus(state, value) {
      state.arrayItemsByStatus = value
    },

    // Desde Varios
    showOverlay(state, value) {
      state.overlayLoading = value
    },
    showSnackBar(state, snack) {
      state.snackbar = snack
    },
    setSnackAdd(state, stateSnack) {
      state.snackbarAdd = stateSnack
    },
    setSnackEdit(state, stateSnack) {
      state.snackbarEdit = stateSnack
    },
    setSnackDelete(state, stateSnack) {
      state.snackbarDelete = stateSnack
    },
    setSnackError(state, stateSnack) {
      state.snackbarError = stateSnack
    },
    // Desde la Accion
    setSnackMSG(state, msg) {
      state.snackbarmsg = msg
    },
    // desde AppBar
    showDrawer(state) {
      state.drawer = !state.drawer
    },
    // desde Drawer Bar
    noShowDrawer(state) {
      state.drawer = false
    },
    // desde Drawer Bar
    yesShowDrawer(state) {
      state.drawer = true
    },

    /**
     * Muestra u oculta el componente "VirtualMachines" del Dashboard
     * dependiendo si encuentra o no valores desde la API en "VirMacDialog"
     * @param state estado de la STORE
     * @param value Boolean 
     */
    setVirtualMachine(state, value) {
      state.showVirMac = value;
    },
  },
  actions: {
    // Enviado desde AdminView, AdminOIDSview, COPYCOmponent
    async getInventoryData({ commit }) {
      await axios.get(APIS_INVENTORY.value.getAllInventoryData, { timeout: TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}` } })
        .then((response) => {
          let finalData = response.data;

          if (process.env.VUE_APP_NAME_PROJECT === 'SmartLinkRAOS') {
            finalData = finalData.filter((item: any) => item.tipo === 'Perforadora')
          }
          commit('addListItems', finalData)
        })
        .catch(function (error) {

          // Si no hay una ruta a la API (no esta definida)
          if (error.response) {
            console.error('no se ha encontrado la ruta a la API');
          }

          // Si la API tiene un error
          else if (error.request) {
            console.error('Error de la API o 30s sin recibir nada');
          }

          // Otros motivos
          else {
            console.error('otro Motivo: ', error)
          }
        })
    },

    //ENVIADO DESDE LASTCONECTION, YAMLMaintenance, DBMaintenance, Login, COPYCOmponent
    async showSnackBar({ commit }, { type, msg }) {
      commit(type, true);
      commit('setSnackMSG', msg);

      setTimeout(() => {
        commit(type, false);
        commit('setSnackMSG', '');
      }, 4000);
    },

    async getAllUsers({ commit }) {
      const allData = await getAllUsersData()

      if (allData.status === 400) {
        commit('showSnackBar', { type: LABELS.error, msg: 'Error en las APIS', valor: true });
      }
      if (allData.status === 200) {
        commit('allUserInfo', allData.data)
      }
    },

  },
  modules: {
  }
})
